import type { RequestPasswordResetFormMessages } from "@my-langguth/auth-ui";
import { RequestPasswordResetForm as SharedRequestPasswordResetForm } from "@my-langguth/auth-ui";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import loginImage from "../assets/login.webp";
import { SHOP_AUTH_API_BASE } from "@/lib/shop-auth-api-base";
import { AuthFormFooter } from "@/components/auth-form-footer";
import { getPrivacyPolicyHref } from "@/lib/app-language";
import { useAppLanguage } from "@/hooks/use-app-language";

export function RequestPasswordResetForm({
  className,
  ...props
}: React.ComponentProps<"div">) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const language = useAppLanguage();

  const privacyPolicyLink = getPrivacyPolicyHref(language);

  const messages: RequestPasswordResetFormMessages = {
    errors: {
      emailRequired: t("auth.errors.emailRequired"),
      emailInvalid: t("auth.errors.emailInvalid"),
      tooManyResetRequests: t("auth.errors.tooManyResetRequests"),
      tooManyResetRequestsDesc: t("auth.errors.tooManyResetRequestsDesc"),
      resetRequestFailed: t("auth.errors.resetRequestFailed"),
      resetRequestFailedDesc: t("auth.errors.resetRequestFailedDesc"),
    },
    resetRequest: {
      title: t("auth.resetRequest.title"),
      subtitle: t("auth.resetRequest.subtitle"),
      submitButton: t("auth.resetRequest.submitButton"),
      backToLogin: t("auth.resetRequest.backToLogin"),
      success: t("auth.resetRequest.success"),
      successDesc: t("auth.resetRequest.successDesc"),
    },
    login: {
      termsOfService: t("auth.login.termsOfService"),
      termsOfServiceLink: t("auth.login.termsOfServiceLink"),
      and: t("auth.login.and"),
      privacyPolicyLink: t("auth.login.privacyPolicyLink"),
      agreeToSuffix: t("auth.login.agreeToSuffix"),
    },
  };

  return (
    <SharedRequestPasswordResetForm
      authBaseUrl={SHOP_AUTH_API_BASE}
      messages={messages}
      language={language}
      heroImageSrc={loginImage}
      privacyPolicyHref={privacyPolicyLink}
      onNavigateToLogin={() =>
        navigate({ to: "/login", search: { redirect: undefined } })
      }
      onSuccess={() =>
        navigate({ to: "/login", search: { redirect: undefined } })
      }
      footerSlot={<AuthFormFooter />}
      className={className}
      {...props}
    />
  );
}
